export const yieldToMainBackground = async () => {
  if ('scheduler' in window) {
    const { scheduler } = window;
    if ('yield' in scheduler) {
      // eslint-disable-next-line no-return-await
      return await scheduler.yield();
    }
  }

  // Fallback to setTimeout if scheduler.yield is not available
  return new Promise(resolve => {
    setTimeout(resolve, 0);
  });
};
export default yieldToMainBackground;
